import { Injectable } from '@angular/core';
import { Api } from './api.service';



@Injectable()
export class Context {
  constructor(
  public api: Api,
  ) { }


  public initDone: boolean = false;



  //public InitContex(): Promise<boolean> {
  //  return new Promise((resolve) => {
  //    //this.fexApi.getAppConfig().then(appConfig => {
  //    //  this.appConfig = appConfig;
  //    //  this.initDone = true;

  //    //  //this.globalLang = new GlobalLang(this.settings.UiLang)
  //    //  resolve(appConfig)
  //    //})
  //    resolve(true)
  //  })
  //}

}
